import React, {Component} from "react";
import {Drawer, Input} from "antd";
import StandardTable from "../../components/StandardTable";

class ProductPriceLogDrawer extends Component {

    dataTable = undefined

    state = {
        searchKeyword: null,
        dateRange: null,
    }

    columns = [
        {
            title: '物料ID',
            dataIndex: 'product_id',
        },
        {
            title: '单位',
            dataIndex: 'unit',
        },
        {
            title: '价格',
            dataIndex: 'price',
        },
        {
            title: '创建人',
            dataIndex: 'create_by',
        },
        {
            title: '创建日期',
            dataIndex: 'create_time',
        },
    ]

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.visible !== this.props.visible && this.props.visible && this.dataTable) {
            this.dataTable.fetch()
        }
    }

    render() {
        return (
            <Drawer width={1100} {...this.props}>
                <div style={{textAlign: 'center'}}>
                    <Input.Search style={{width: 500}}
                                  enterButton="搜索"
                                  onSearch={(value) => this.setState({searchKeyword: value})}
                    />
                </div>
                <br/>
                <StandardTable columns={this.columns}
                               rowKey={'id'}
                               ref={(table) => this.dataTable = table}
                               url={'/api/product/price/log'}
                               keyword={this.state.searchKeyword}
                               filters={{
                                   dateRange: this.state.dateRange
                               }}
                />
            </Drawer>
        )
    }
}

export default ProductPriceLogDrawer